import { useCreate, useHandleNotification } from "@refinedev/core";
import { useResourceNavigate } from "./useResourceNavigate";
import { useTranslation } from "react-i18next";
import { useResourceContext } from "@/layouts/ResourceContext";

export const useResourceCreate = (props) => {
  const { resource, meta: metaFromProps } = props;
  const navigate = useResourceNavigate();
  const { t } = useTranslation();
  const handleNotification = useHandleNotification();
  const { tenantName } = useResourceContext();
  let meta = metaFromProps;
  if (!meta) {
    meta = { tenantName };
  } else if (!meta.tenantName) {
    meta.tenantName = tenantName;
  }

  const resp = useCreate({
    mutationOptions: {
      onSuccess: (data, variables) => {
        handleNotification({
          message: t(`${resource}.actionResult.create.success`, { ...variables?.values, ...data }),
          type: "success"
        });
        navigate({ resource, action: "list" });
      },
    },
    errorNotification: (error, values, resource) => {
      return {
        message: t(`${resource}.actionResult.create.failed`, values),
        type: "error"
      };
    },
    ...props,
    meta,
  });
  return resp;
};